import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";
import InputError from "../typography/InputError";

const Wrapper = styled.div`
  flex: 1 1 calc(50% - 13px);
  min-width: 250px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  input {
    box-sizing: border-box;
    width: 100%;
    border: 1px solid
      ${({ $hasError }) => ($hasError ? colors.black : colors.border)};
    padding: 12px 10px;
    outline: none;
    caret-color: ${colors.black};
    font-size: ${fontSize.xxs};
  }

  label {
    font-size: ${fontSize.xxs};
  }
`;

function TextField({ text, type = "text", label, value, error, onChange, onFocus }) {
  const inputId = text.replace(/\s+/g, "-").toLowerCase();
  return (
    <Wrapper $hasError={!!error}>
      {label && <label htmlFor={inputId}>{label}</label>}
      <input
        type={type}
        placeholder={`*${text}`}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
      />
      {error && <InputError error={error} />}
    </Wrapper>
  );
}

export default TextField;
